import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { bool, func } from "prop-types";
import { Button, Col, ControlLabel, FormControl, FormGroup, HelpBlock, Icon, InputGroup } from "@icg360/ui-toolkit";
import { formFieldPropTypes, pacDataPropTypes } from "../../shared/propTypes";
var NAME = "attachment";

var Attachment = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Attachment, _Component);

  function Attachment(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleOnChange = function (e) {
      var _this$props = _this.props,
          attachmentSizeLimitMB = _this$props.pacData.attachmentSizeLimitMB,
          updateFormField = _this$props.updateFormField;
      var selectedAttachment = e.target.files[0];

      if (selectedAttachment) {
        var fileSize = getFileSizeInMB(selectedAttachment.size);
        updateFormField(NAME, {
          value: selectedAttachment,
          isValid: fileSize <= attachmentSizeLimitMB,
          isTouched: true
        });
      }
    };

    _this.resetFileInput = function () {
      var updateFormField = _this.props.updateFormField;
      updateFormField(NAME, {
        value: "",
        isValid: true,
        isTouched: true
      });
    };

    _this.triggerFileInput = function () {
      _this.fileInput.current.click();
    };

    _this.fileInput = /*#__PURE__*/React.createRef();
    return _this;
  }

  var _proto = Attachment.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$attachme = _this$props2.attachment,
        isRequired = _this$props2$attachme.isRequired,
        isTouched = _this$props2$attachme.isTouched,
        isValid = _this$props2$attachme.isValid,
        value = _this$props2$attachme.value,
        attachmentSizeLimitMB = _this$props2.pacData.attachmentSizeLimitMB,
        formSubmitAttempted = _this$props2.formSubmitAttempted;
    var showRequiredError = (isTouched || formSubmitAttempted) && isRequired && !value;
    var showValidityError = (isTouched || formSubmitAttempted) && !isValid;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      id: NAME,
      name: NAME,
      ref: this.fileInput,
      style: {
        display: "none"
      },
      type: "file",
      onChange: this.handleOnChange
    }), /*#__PURE__*/React.createElement(FormGroup, {
      controlId: NAME,
      validationState: showRequiredError || showValidityError ? "error" : null
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 4
    }, /*#__PURE__*/React.createElement(ControlLabel, null, "Attachment (", attachmentSizeLimitMB, " MB size limit)")), /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, /*#__PURE__*/React.createElement(InputGroup, null, value ? /*#__PURE__*/React.createElement(InputGroup.Button, null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.resetFileInput,
      title: "Delete"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "delete"
    }))) : /*#__PURE__*/React.createElement(InputGroup.Button, null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.triggerFileInput
    }, "Choose File")), /*#__PURE__*/React.createElement(FormControl, {
      type: "text",
      disabled: true,
      value: value ? value.name : ""
    })), showValidityError && /*#__PURE__*/React.createElement(HelpBlock, null, "File must be less than ", attachmentSizeLimitMB, "MB (the file you selected is ", getFileSizeInMB(value.size), "MB)"), showRequiredError && /*#__PURE__*/React.createElement(HelpBlock, null, "Documentation supporting requested change is required."))));
  };

  return Attachment;
}(Component);
/**
 * Convert bytes to MB, then round up (i.e. 2.00001 -> 2.1)
 * @param {Number} bytes
 */


Attachment.propTypes = {
  attachment: formFieldPropTypes,
  formSubmitAttempted: bool.isRequired,
  pacData: pacDataPropTypes.isRequired,
  updateFormField: func.isRequired
};
export { Attachment as default };

function getFileSizeInMB(bytes) {
  return Math.ceil(bytes / 1024 / 1024 * 10) / 10;
}